import { MEAL_LABEL } from "@shared/meals";

/** What the Log activity form offers. "lunch" is a meeting flagged as a meal, so the spoken-to checkmark still counts it. */
export const LOG_OPTIONS = ["note", "call", "meeting", "lunch", "conference"] as const;
export type LogOption = (typeof LOG_OPTIONS)[number];

export const LOG_LABEL: Record<LogOption, string> = {
  note: "Note", call: "Call", meeting: "Meeting", lunch: MEAL_LABEL, conference: "Conference",
};

export const isLogOption = (x: unknown): x is LogOption => (LOG_OPTIONS as readonly unknown[]).includes(x);

/** A lunch is a meeting with the meal flag; every other option is its own activity type. */
export function activityTypeFor(option: string): { type: string; meal: boolean } {
  return option === "lunch" ? { type: "meeting", meal: true } : { type: option, meal: false };
}
